// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T1y-","name":"styles_name__1mpjY","phone":"styles_phone__1VBb1"};